import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useReframe } from 'nike-re-framejs';
import { denormalizeSportEventId } from '@/nikeone/domain/sportevent';
import RowScoreboard, { PrematchScoreboard } from '@/scoreboards/views/RowScoreboard';
import { fireGAEvent } from '@/analytics';
import { NIKE1_MATCH } from '@/routing/routes';
import { navigate } from '@/routing';
import { sportEventUrlDescription } from 'nike-ui/src/common/sportEvents';
import { toSportType } from 'nike-ui/src/common/sports';

export function RecentlyVisitedItemSub({ eventId }) {
    const derefSub = useReframe();
    const event = derefSub(['sub::recently-visited.events.event', eventId]);

    if (!event.get('hasBoxesData')) {
        return null;
    }

    return <RecentlyVisitedItem event={event} />;
}

export class RecentlyVisitedItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = { disabled: true };
        this.handleClick = this.handleClick.bind(this);
    }

    static propTypes = {
        event: PropTypes.any
    };

    static getDerivedStateFromProps(props) {
        const { event } = props;
        return { disabled: !event.get('hasBoxesData') };
    }

    handleClick() {
        const { event } = this.props;
        const { disabled } = this.state;

        if (disabled) {
            return;
        }

        const eventId = denormalizeSportEventId(event.get('sportEventId'));
        fireGAEvent('Moja Historia', 'Prechod do detailu zapasu');
        navigate(NIKE1_MATCH, { eventId: eventId, meta: sportEventUrlDescription(event) });
    }

    render() {
        const { event } = this.props;

        return (
            <div className={clsx('top-live-item', { disabled: !event.get('hasBoxesData') })} onClick={this.handleClick}>
                <div
                    data-atid="sport-icon"
                    className={'top-live-icon sport-icon-mini icon-' + toSportType(event.get('sportId'))}
                />
                {event.get('hasLiveData') ? (
                    <RowScoreboard
                        sportId={event.get('sportId')}
                        event={event}
                        clock="recently-visited.tick"
                        numberOfBettingEvents
                        streams
                    />
                ) : (
                    <PrematchScoreboard event={event} />
                )}
            </div>
        );
    }
}
